import React from "react";
import { Container, Typography } from "@mui/material";

export default function StatsDashboard() {
  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        StatsDashboard Placeholder
      </Typography>
    </Container>
  );
}
